import { useEffect, useState } from "react";

/**
 * Remembers the last non-empty value it was given.
 *
 * Modals close with an animation, so their card stays on screen for a moment
 * after `open` goes false. Feed the modal's title/body/footer from this instead
 * of straight from the row that opened it, or the content blinks away before the
 * animation has finished — the row is usually cleared in the very same render
 * that starts the close.
 */
export function useLastPresent<T>(value: T | null | undefined): T | null {
    const [lastPresent, setLastPresent] = useState<T | null>(value ?? null);

    // Only ever moves forward, so it survives the value being cleared.
    useEffect(() => {
        if (value !== null && value !== undefined) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setLastPresent(value);
        }
    }, [value]);

    return value ?? lastPresent;
}
